import { frontendURL } from '../../../../helper/URLHelper';
import {
  SURVEY_VIEW_PERMISSIONS,
  SURVEY_MANAGE_PERMISSIONS,
  SURVEY_CREATE_PERMISSIONS,
} from 'dashboard/constants/permissions';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');
const SurveyForm = () => import('./SurveyForm.vue');
const SurveyWallet = () => import('./SurveyWallet.vue');

// Toda rota nomeada precisa de `meta.permissions`: `buildPermissionsFromRouter` lança erro
// no boot do router se faltar.
const VIEW = [
  'administrator',
  SURVEY_VIEW_PERMISSIONS,
  SURVEY_MANAGE_PERMISSIONS,
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/surveys'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'surveys_wrapper',
          meta: { permissions: VIEW },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'surveys_list',
          meta: { permissions: VIEW },
          component: Index,
        },
        {
          path: 'new',
          name: 'surveys_new',
          meta: {
            permissions: [
              'administrator',
              SURVEY_CREATE_PERMISSIONS,
              SURVEY_MANAGE_PERMISSIONS,
            ],
          },
          component: SurveyForm,
        },
        {
          // A edição abre para quem só tem leitura; o botão de salvar é que fica
          // desabilitado sem `survey_edit`.
          path: ':surveyId/edit',
          name: 'surveys_edit',
          meta: { permissions: VIEW },
          component: SurveyForm,
          props: true,
        },
        {
          path: ':surveyId/wallet',
          name: 'surveys_wallet',
          meta: { permissions: VIEW },
          component: SurveyWallet,
          props: true,
        },
      ],
    },
  ],
};
